<template>
  <div class="container-fluid">
    <div
      class="fondo row mt-4 d-flex flex-row justify-content-center align-items-center"
    >
      <div class="col-6 mb-3">
        <img src="@/assets/gabriel.png" alt="" class="d-none d-md-block" />
      </div>
      <div class="col-10 col-md-6 text-center">
        <h1 class="mb-3">Multiservicios GMM</h1>
        <!-- <div class="input-group mb-3 w-100 p-5">
          <select
            class="form-select"
            id="inputGroupSelect04"
            aria-label="Example select with button addon"
            v-model="selectedOption"
            @change="handleClick"
          >
            <option selected>Servicios...</option>
            <option
              v-for="(servicio, index) in servicios"
              :key="index"
              :value="servicio.value"
            >
              {{ servicio.label }}
            </option>
          </select>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: "",
      servicios: [
        { value: "1", label: "Plomeria" },
        { value: "2", label: "Electricidad" },
        { value: "3", label: "Pintura" },
        { value: "4", label: "Drywall" },
        { value: "5", label: "Ceramicos y Baldosas" },
        { value: "6", label: "PVC Decoraciones" },
        { value: "7", label: "Ventanas y Puertas" },
        { value: "8", label: "Cocinas" },
        { value: "9", label: "Carpinterias" },
        { value: "10", label: "Techos y Tejados" },
        { value: "11", label: "Estructuras Metalicas" },
        { value: "12", label: "Escaleras" },
        { value: "13", label: "Soldaduras y Cerrageria" },
      ],
    };
  },
  methods: {
    handleClick() {
      if (this.selectedOption) {
        this.$router.push({
          name: "Servicio",
          params: { nombre: this.selectedOption },
        });
      }
    },
  },
};
</script>

<style scoped>
.container-fluid {
  background: url("../assets/img2.jpg") no-repeat center center;
  height: 50vh;
  background-size: cover;
}
h1 {
  text-size-adjust: auto;
  size: 4rem;
  color: #06c406;
  text-shadow: 0px 0px 5px rgb(170, 190, 176);
}
img {
  width: 200px;
  height: auto;
  border-radius: 50%;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}
</style>
